import React from 'react';
import { Spinner } from 'react-bootstrap';
import { Redirect, Route, useHistory, useLocation } from 'react-router';
import useAuth from '../Hooks/useAuth';


const PrivateRoute = ({children, ...rest}) => {
    
    let history = useHistory();
    let location = useLocation();
    const {user,isLoading}=useAuth();

    if(isLoading){
      return <Spinner animation="border" variant="danger" />
    }
    return (
      
        <Route
        {...rest}
        render={({ location }) =>
          user.email ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: location }
              }}
            />
          )
        }
      />
    
  
    );
};

export default PrivateRoute;